import * as React from 'react';
import { Component } from 'react';
import { IClinicListItem } from '../../models/IClinicListItem';
import { ClinicService } from '../../services/ClinicService';
import { Redirect } from 'react-router';
import { ITherapy } from '../../models/ITherapy';
import { GetGeolocation, GetDistanceFromLatLonInKm } from '../../utils/Geolocation';
import { IsNullEmptyOrUndefined } from '../../utils/IsNullEmptyOrUndefined';
import { PhoneModalComponent } from './PhoneModal';

interface IProps {
    PhysiotherapistId?: string,
    Item: IClinicListItem,
    OnRefreshRequired: () => void,
    IsFirst: boolean,
    ShowClinicOnMap?: (clinic: IClinicListItem) => void,
    IsTele: boolean;
    IsHomeService: boolean;
}

interface IState {
    ShowAllTherapies: boolean,
    DoRedirect: boolean,
    RedirectId?: number,
    Coordinates?: Coordinates,
    PhoneModalVisible: boolean,
    PhoneNumberVisible: boolean,
    ShowMore: boolean
}

export class ClinicListItemComponent extends Component<IProps, IState> {
    constructor(props) {
        super(props);

        this.state = {
            ShowAllTherapies: false,
            DoRedirect: false,
            PhoneModalVisible: false,
            PhoneNumberVisible: false,
            ShowMore: false
        }

        this.OnDeleteClick = this.OnDeleteClick.bind(this);
        this.OnDeleteSuccess = this.OnDeleteSuccess.bind(this);
        this.OnDeleteError = this.OnDeleteError.bind(this);
        this.ShowMore = this.ShowMore.bind(this);
        this.ShowLess = this.ShowLess.bind(this);
        this.ShowClinicOnMap = this.ShowClinicOnMap.bind(this);
        this.SetCoordinates = this.SetCoordinates.bind(this);
        this.ClosePhoneModal = this.ClosePhoneModal.bind(this);
        this.OpenPhoneModal = this.OpenPhoneModal.bind(this);
        this.ShowMorePaymentInfo = this.ShowMorePaymentInfo.bind(this);

        GetGeolocation(this.SetCoordinates);
    }

    public renderTele0() {
        return (
            <>
                <h2>Telerehabilitacja</h2>
                <p className="tele-info">
                    {
                        IsNullEmptyOrUndefined(this.props.Item.Comment) ?
                            'Telerehabilitacje odbywają się za pośrednictwem Skype. Instrukcję oraz link otrzymają Państwo w mailu przed spotkaniem.' :
                            this.props.Item.Comment
                    }
                </p>
            </>
        );
    }

    public renderTele1() {
        return (
            <>
                <span>Telerehabilitacja</span>
            </>
        );
    }

    public renderHomeService1() {
        return (
            <>
                <span>{this.props.Item.FullName}</span>
                <span>{this.props.Item.FullAddress}</span>
            </>
        );
    }

    public renderAddress1() {
        return (
            <>
                <span>{this.props.Item.FullName}</span>
                <span>{this.props.Item.FullAddress}</span>
            </>
        );
    }


    public render() {
        return (
            <li className={"section clinic-section" + (this.props.IsTele ? " tele-clinic" : this.props.IsHomeService ? " home-service-clinic" : "")}>
                {this.RenderRedirect()}
                {this.RenderPhoneModal()}
                {
                    this.props.IsFirst ?
                        (<h2>Adres</h2>) :
                        null
                }
                {
                    this.props.IsTele ?
                        this.renderTele0() : null
                }
                <div className="clinic-address-section">
                    <div className="left-address-section clinic-address">
                        {
                            this.props.IsTele ?
                                this.renderTele1() : this.props.IsHomeService ?
                                    this.renderHomeService1() : this.renderAddress1()

                        }
                    </div>
                    <div className="right-address-section">
                        {this.RenderDistance()}
                        {
                            this.props.ShowClinicOnMap !== undefined &&
                                this.props.Item.Lat !== 0 &&
                                this.props.Item.Lat !== 0 ?
                                (<a onClick={this.ShowClinicOnMap}>Pokaż na mapie</a>) :
                                null
                        }
                    </div>
                </div>
                {
                    IsNullEmptyOrUndefined(this.props.Item.Phone) ?
                        null :
                        (<div className="clinic-phone-section">
                            <button className="std-secondary-btn-alt" onClick={this.OpenPhoneModal}>Pokaż numer</button>
                        </div>)

                }
                <div className="clinic-address-line-div" />
                <div className="clinic-info-section">
                    <div className="price-list-section">
                        {this.RenderTherapies()}
                        {this.RenderRedirectToTherapiesButton()}
                    </div>
                    <div className="other-info-section">
                        {this.RenderPaymentSection()}
                    </div>
                </div>
                {
                    this.props.PhysiotherapistId === undefined ?
                        (<a><span className="delete-btn" onClick={this.OnDeleteClick.bind(this, this.props.Item.Id)}>Usuń klinikę</span></a>) :
                        null
                }
            </li>
        );
    }//end-of-render

    public RenderPaymentSection() {
        if (this.props.IsTele) {
            if (IsNullEmptyOrUndefined(this.props.Item.OtherTransferMethods)) {
                return (<span className="payment">przelew</span>);
            } else {
                return (
                    <>
                        <span className={"payment" + (this.state.ShowMore ? " show-all" : "")}>przelew, {this.props.Item.OtherTransferMethods}</span>
                        {
                            this.state.ShowMore ?
                                null :
                                (<a onClick={this.ShowMorePaymentInfo}>Pokaż więcej</a>)
                        }
                    </>
                );
            }
        } else {
            return (this.props.Item.PaymentCash === true && this.props.Item.PaymentCard === true) ?
                (<span className="payment">gotówka, karta</span>) :
                (
                    this.props.Item.PaymentCash === true ?
                        (<span className="payment">gotówka</span>) :
                        (
                            this.props.Item.PaymentCard === true ?
                                (<span className="payment">karta</span>) :
                                null
                        )
                );
        }
    }

    public RenderPhoneModal() {
        if (this.state.PhoneModalVisible) {
            return (
                <PhoneModalComponent
                    ClosePhoneModal={this.ClosePhoneModal}
                    Phone={this.props.Item.Phone}
                    IsHomeService={this.props.Item.IsHomeService}
                    PhysiotherapistId={this.props.PhysiotherapistId}
                    ClinicId={this.props.Item.Id} />
            );
        } else {
            return null;
        }
    }

    public RenderDistance() {
        if (this.state.Coordinates !== undefined &&
            this.props.Item.Lat !== 0 &&
            this.props.Item.Lng !== 0 &&
            this.props.Item.Lat !== undefined &&
            this.props.Item.Lng !== undefined
        ) {
            let distance = GetDistanceFromLatLonInKm(
                this.state.Coordinates.latitude,
                this.state.Coordinates.longitude,
                this.props.Item.Lat,
                this.props.Item.Lng);
            return (<span>odległość: ok {distance.toFixed(0).replace('.', ',')}km</span>);
        } else {
            return (<span>&nbsp;</span>)
        }
    }

    public RenderTherapies() {
        let therapies: null | ITherapy[] = null;
        if (this.state.ShowAllTherapies) {
            therapies = this.props.Item.Therapies;
        } else {
            therapies = this.props.Item.Therapies.filter((i, index) => (index < 3));
        }
        let buttons: null | JSX.Element = null;
        if (this.props.Item.Therapies.length > 3) {
            if (this.state.ShowAllTherapies) {
                buttons = (<li key={0}><a onClick={this.ShowLess}>zobacz mniej</a></li>)
            } else {
                buttons = (<li key={0}><a onClick={this.ShowMore}>zobacz więcej</a></li>)
            }
        }
        return (
            <div className="form-row price-list">
                <ul>
                    {
                        therapies.map((therapy) => (
                            <li key={therapy.Id}>
                                <span className="therapy-name">{therapy.Name}</span>
                                <span className="price">{therapy.Price ? 'od ' + therapy.Price + ' zł' : ''}</span>
                            </li>
                        ))
                    }
                    {buttons}
                </ul>
            </div>
        );
    }

    public RenderRedirect() {
        if (this.state.DoRedirect) {
            return <Redirect to={'/therapies/' + this.state.RedirectId} push={true} />
        } else {
            return null;
        }
    }

    private RenderRedirectToTherapiesButton() {
        if (this.props.PhysiotherapistId === undefined) {
            return (
                <div className="buttons">
                    <a onClick={this.RedirectToTerapies.bind(this, this.props.Item.Id)}>[Uzupełnij terapie]</a>
                </div>
            );
        } else {
            return null;
        }
    }

    private OnDeleteClick(id, evt) {
        let service = new ClinicService();
        service.RemoveClinic(id, this.OnDeleteSuccess, this.OnDeleteError);
    }

    private OnDeleteSuccess(result) {
        this.props.OnRefreshRequired();
    }

    private OnDeleteError(error) {
        console.error(error);
    }

    private RedirectToTerapies(id: number, evt) {
        this.setState({
            RedirectId: id,
            DoRedirect: true
        });
    }

    private ShowMore(evt) {
        this.setState({
            ShowAllTherapies: true
        });
    }

    private ShowLess(evt) {
        this.setState({
            ShowAllTherapies: false
        });
    }

    private ShowClinicOnMap(evt) {
        if (this.props.ShowClinicOnMap) {
            this.props.ShowClinicOnMap(this.props.Item);
        }
    }

    private SetCoordinates(position: Position) {
        this.setState({
            Coordinates: position.coords
        });
    }

    private ClosePhoneModal() {
        this.setState({
            PhoneModalVisible: false,
            PhoneNumberVisible: false
        });
    }

    private OpenPhoneModal() {
        this.setState({
            PhoneModalVisible: true,
            PhoneNumberVisible: false
        });
    }

    private ShowMorePaymentInfo() {
        this.setState({
            ShowMore: true
        })
    }
}


// WEBPACK FOOTER //
// ./src/components/Clinic/ClinicListItem.tsx